var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDigitalFusion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 153,
    viewBox: "0 0 148 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M131.246 17.5222C131.546 23.2222 124.946 28.6222 124.946 28.6222C124.946 28.6222 123.446 27.8222 120.246 26.8222C119.646 26.6222 118.979 26.4222 118.246 26.2222C115.446 25.4222 111.746 24.5222 107.246 23.7222C104.113 23.1222 100.513 22.6222 96.4462 22.2222C89.5462 21.5222 81.4461 21.2222 72.0461 21.5222C62.1461 21.9222 50.7462 23.1222 37.9462 25.4222C34.6795 26.0222 31.3128 26.6889 27.8461 27.4222C27.0461 27.5555 26.2795 27.7222 25.5461 27.9222C13.7461 30.5222 24.7461 9.42222 24.7461 9.42222C24.7461 9.42222 27.8461 8.32222 33.1461 6.82222C33.8128 6.62222 34.5461 6.42222 35.3461 6.22222C36.3461 5.95555 37.4461 5.68889 38.6461 5.42222C40.3128 5.02222 42.1128 4.62222 44.0461 4.22222C44.1128 4.22222 44.1461 4.18889 44.1461 4.12222C44.2128 4.12222 44.4128 4.08888 44.7461 4.02222C53.7461 2.22222 65.1461 0.622217 77.5461 0.522217C84.0461 0.522217 90.8461 0.922217 97.6461 2.02222C98.5794 2.15555 99.5128 2.32222 100.446 2.52222C105.046 3.22222 109.546 4.32222 114.146 5.82222C117.413 6.82222 120.646 8.02222 123.846 9.42222C129.246 11.8222 131.146 14.6222 131.246 17.5222Z",
    fill: "url(#paint0_linear_62_989)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M118.246 26.2222C105.746 22.5222 75.7462 17.0222 27.8462 27.4222L28.5462 26.3222C28.5462 26.3222 52.1462 19.9222 75.6462 20.3222C99.2462 20.6222 113.546 23.5222 117.746 25.4222C118.213 25.6222 118.379 25.8889 118.246 26.2222Z",
    fill: "url(#paint1_linear_62_989)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9462 25.4222C34.6795 26.0222 31.3128 26.6889 27.8461 27.4222C27.0461 27.5556 26.2795 27.7222 25.5461 27.9222C13.7461 30.5222 24.7461 9.42224 24.7461 9.42224C24.7461 9.42224 27.8461 8.32224 33.1461 6.82224C33.8128 6.62224 34.5461 6.42224 35.3461 6.22224C36.3461 5.95557 37.4461 5.68891 38.6461 5.42224C35.6461 10.0222 33.7462 16.8222 37.9462 25.4222Z",
    fill: "#912774"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M131.246 17.5222C131.546 23.2222 124.946 28.6222 124.946 28.6222C124.946 28.6222 123.446 27.8222 120.246 26.8222C119.646 26.6222 118.98 26.4222 118.246 26.2222C115.446 25.4222 111.746 24.5222 107.246 23.7222C108.446 15.3222 104.646 7.82222 100.446 2.52222C108.346 3.82222 116.246 6.02222 123.846 9.42222C129.246 11.8222 131.146 14.6222 131.246 17.5222Z",
    fill: "#912774"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2461 88.8222C61.2461 88.8222 59.3462 87.3222 56.3462 84.7222C54.6462 83.3222 52.6462 81.7222 50.4462 79.8222C48.3462 77.9222 45.9462 75.8223 43.4462 73.5222C27.4462 59.2222 5.84618 37.9222 0.846182 23.9222C-0.0538179 21.6222 24.7462 9.42224 24.7462 9.42224L24.8462 9.52224C24.8462 9.52224 24.8462 9.55558 24.8462 9.62224C25.5462 11.2222 33.6462 29.4222 43.0462 46.9222C45.9462 52.5222 49.1462 58.0222 52.1462 62.9222C56.2462 69.6222 60.2462 75.0222 63.5462 78.0222C64.1462 78.5556 64.7128 78.9889 65.2461 79.3222C78.6461 88.3222 61.2461 88.8222 61.2461 88.8222Z",
    fill: "url(#paint2_linear_62_989)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M147.846 23.9222C142.746 38.1222 120.646 59.8222 104.546 74.1222C94.8461 82.8222 87.4461 88.8222 87.4461 88.8222C87.4461 88.8222 69.9461 88.3222 83.4461 79.3222C85.0461 78.3222 86.7461 76.5222 88.6461 74.2222C91.0461 71.3222 93.7462 67.4222 96.3462 63.1222C109.046 42.8222 123.046 11.5222 123.846 9.52224V9.42224C123.913 9.42224 123.913 9.42224 123.846 9.42224C123.846 9.42224 148.646 21.6222 147.846 23.9222Z",
    fill: "url(#paint3_linear_62_989)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0461 80.6222C53.8461 81.1222 36.9461 67.5222 41.5461 61.0222C46.2461 54.5222 57.7461 73.8222 54.0461 80.6222Z",
    fill: "#912774"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M90.846 80.8222C89.346 80.5222 99.846 54.0222 106.146 60.7222C112.446 67.3222 92.646 81.1222 90.846 80.8222Z",
    fill: "#912774"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.7
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2462 79.3221L56.3463 84.7221C53.0463 82.0221 48.5463 78.1221 43.4463 73.5221C45.7463 69.8221 48.7462 65.9221 52.1462 62.9221C56.9462 70.7221 61.5462 76.9221 65.2462 79.3221Z",
    fill: "#CA2790"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.7
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M104.546 74.1223C94.8461 82.8223 87.4461 88.8223 87.4461 88.8223C87.4461 88.8223 69.9461 88.3223 83.4461 79.3223C87.0461 76.9223 91.6462 70.8223 96.3462 63.1223C98.9462 65.7223 102.146 69.6223 104.546 74.1223Z",
    fill: "#CA2790"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M123.846 9.42224C123.546 10.4222 116.646 31.3222 109.446 44.0222C102.146 57.0222 89.546 75.0222 89.546 75.0222L88.646 74.2222C91.046 71.3222 93.7461 67.4222 96.3461 63.1222C109.046 42.8222 123.046 11.5222 123.846 9.52224V9.42224Z",
    fill: "#600090"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7462 79.8222H50.4462C48.3462 77.9222 45.9462 75.8222 43.4462 73.5222C27.4462 59.2222 5.84619 37.9222 0.846191 23.9222C0.846191 23.9222 9.74618 38.7222 17.6462 46.4222C25.4462 54.0222 50.7462 79.8222 50.7462 79.8222Z",
    fill: "#600090"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M5.84599 23.7223C7.74599 18.7223 20.646 9.62228 22.446 14.1223C24.246 18.6223 53.646 58.3223 38.146 54.0223C22.646 49.6223 4.64599 26.7223 5.84599 23.7223Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M109.446 53.4222C110.046 51.8222 121.946 17.1222 130.146 17.7222C138.246 18.4222 146.646 21.9222 143.946 26.1222C141.246 30.2222 107.146 59.2222 109.446 53.4222Z",
    fill: "white"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7461 9.42224L24.8461 9.52224C24.7794 9.45557 24.7461 9.42224 24.7461 9.42224Z",
    fill: "#FF4F90"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0462 46.9222C41.6462 45.2222 40.2462 43.2222 38.7462 40.9222C32.6462 31.0222 25.4462 11.4222 24.8462 9.62219C25.5462 11.2222 33.6462 29.4222 43.0462 46.9222Z",
    fill: "#FF4F90"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M44.146 4.12222C44.2127 4.12222 44.4127 4.08888 44.746 4.02222C53.746 2.22222 65.146 0.622217 77.546 0.522217C84.046 0.522217 90.846 0.922217 97.646 2.02222C98.5793 2.15555 99.5127 2.32222 100.446 2.52222C105.046 3.22222 109.546 4.32222 114.146 5.82222C115.013 6.08888 115.713 6.35555 116.246 6.62222C120.446 8.42222 91.446 -3.67778 44.146 4.12222Z",
    fill: "#FF4F90"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M54.346 76.3222C54.246 76.0222 50.046 61.4222 45.346 61.3222C40.646 61.1222 50.646 79.1222 52.346 78.6222C54.046 78.2222 54.346 76.3222 54.346 76.3222Z",
    fill: "#912774"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1463 76.3221C91.9463 76.1221 99.8464 59.1221 103.346 61.5221C106.846 63.8221 101.646 77.1221 93.1463 76.3221Z",
    fill: "#912774"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M111.346 109.022C111.346 130.822 94.7463 148.422 74.3463 148.422C69.7463 148.422 65.4462 147.622 61.4462 146.022C47.3462 140.422 37.3462 126.022 37.3462 109.022C37.3462 93.4222 45.7462 80.0222 57.9462 73.6222H58.0462C58.7129 73.2222 59.3795 72.8889 60.0462 72.6222C64.4462 70.6222 69.2463 69.5222 74.3463 69.5222C87.1463 69.5222 98.3462 76.5222 105.046 87.0222C108.946 93.3222 111.346 100.822 111.346 109.022Z",
    fill: "url(#paint4_linear_62_989)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M111.946 113.522C111.946 114.989 111.846 116.422 111.646 117.822C110.346 130.622 103.146 141.622 92.9462 147.722C87.4462 151.022 81.1462 152.922 74.4462 152.922H74.1462C69.5462 152.922 65.1462 152.122 61.0462 150.522C46.6462 144.922 36.3462 130.522 36.3462 113.522C36.3462 112.722 36.3796 111.922 36.4462 111.122C37.2462 96.6222 45.6462 84.2222 57.4462 78.1222L57.5462 78.0222C58.2129 77.6889 58.8795 77.3889 59.5462 77.1222C64.0462 75.1222 68.9462 74.0222 74.1462 74.0222C87.2462 74.0222 98.7462 81.0222 105.446 91.5222C109.546 97.8222 111.946 105.322 111.946 113.522Z",
    fill: "url(#paint5_linear_62_989)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M111.646 117.822C110.346 130.622 103.146 141.622 92.946 147.722C92.246 147.322 91.646 146.822 91.546 146.222C90.346 142.722 98.046 138.722 99.146 137.222C99.146 137.222 98.746 120.322 109.446 117.822C110.246 117.689 110.979 117.689 111.646 117.822Z",
    fill: "#BD3EA9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4462 152.922H74.1462C69.5462 152.922 65.1462 152.122 61.0462 150.522C46.6462 144.922 36.3462 130.522 36.3462 113.522C36.3462 112.722 36.3796 111.922 36.4462 111.122L40.4462 119.522C40.8462 120.422 47.5462 142.822 65.5462 148.322C71.3462 150.022 74.0462 151.322 74.4462 152.922Z",
    fill: "#BD3EA9"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M111.346 109.022C111.346 130.822 94.7463 148.422 74.3463 148.422C69.7463 148.422 65.4462 147.622 61.4462 146.022C47.3462 140.422 37.3462 126.022 37.3462 109.022C37.3462 93.4222 45.7462 80.0222 57.9462 73.6222H58.0462C58.7129 73.2222 59.3795 72.8889 60.0462 72.6222C64.4462 70.6222 69.2463 69.5222 74.3463 69.5222C87.1463 69.5222 98.3462 76.5222 105.046 87.0222C108.946 93.3222 111.346 100.822 111.346 109.022Z",
    fill: "url(#paint6_linear_62_989)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M50.146 102.522C44.446 102.722 41.646 108.422 41.646 115.822C41.646 123.122 50.646 143.122 69.446 145.122C88.346 147.122 96.946 138.122 99.546 134.722C104.946 127.622 110.946 115.822 104.546 114.022C98.146 112.322 94.446 116.122 94.446 116.122L50.146 102.522Z",
    fill: "white"
  }))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0464 124.122C40.0464 124.122 49.9464 152.422 78.3464 148.722C106.846 145.122 110.346 117.822 110.346 117.822C110.346 117.822 102.846 146.622 77.1464 147.622C49.9464 148.822 40.0464 124.122 40.0464 124.122Z",
    fill: "#FFE016"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M108.146 106.422C104.446 109.322 100.846 109.622 98.9465 105.222C97.0465 100.922 53.6464 99.0222 48.1464 91.9222C46.0464 89.2222 46.1464 87.2222 50.3464 81.4222C52.5464 78.3222 55.5465 75.2222 60.0465 72.6222C64.4465 70.6222 69.2465 69.5222 74.3465 69.5222C87.1465 69.5222 98.3465 76.5222 105.046 87.0222C107.946 95.4222 111.346 103.822 108.146 106.422Z",
    fill: "white"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M100.446 111.022C100.379 111.689 100.313 112.389 100.246 113.122C99.646 116.822 98.4461 121.622 95.3461 125.922V126.022C91.9461 130.722 86.3461 134.822 76.8461 135.822C76.1127 135.956 75.3127 136.056 74.4461 136.122C74.4461 136.122 74.4127 136.122 74.3461 136.122C74.2794 136.122 74.2127 136.122 74.146 136.122C73.6127 136.122 73.0794 136.089 72.546 136.022C68.546 135.722 65.5461 133.022 63.3461 129.122C58.0461 119.922 56.946 104.322 56.646 97.0223C56.546 94.8223 56.646 93.3223 56.646 93.1223C56.646 93.1223 65.546 81.1223 81.746 83.7223C95.846 85.9223 101.246 103.322 100.446 111.022Z",
    fill: "url(#paint7_linear_62_989)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M97.4463 110.722V110.822C97.4463 115.822 96.1462 120.422 93.7462 124.322C93.2795 125.122 92.7462 125.922 92.1462 126.722C88.4462 131.622 83.0463 135.022 76.8463 135.922C76.113 135.989 75.313 136.055 74.4463 136.122C74.4463 136.122 74.413 136.122 74.3463 136.122C74.1463 136.122 73.9462 136.122 73.7462 136.122C73.3462 136.122 72.9463 136.089 72.5463 136.022C67.3463 135.822 62.4462 133.722 58.6462 130.422C54.5462 126.822 51.6463 121.822 50.4463 116.022C50.113 114.355 49.9463 112.589 49.9463 110.722C49.9463 109.455 50.0463 108.189 50.2463 106.922C50.6463 104.022 51.4463 101.322 52.7463 98.9221C53.7463 96.8221 55.0462 94.8221 56.6462 93.1221C60.9462 88.4221 67.0462 85.4221 73.7462 85.4221C81.7462 85.4221 88.8462 89.7221 93.1462 96.2221C95.8462 100.322 97.4463 105.322 97.4463 110.722Z",
    fill: "#FF6B04"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M95.3461 126.022C93.9461 132.022 84.846 138.622 74.046 138.122C64.846 137.722 59.046 130.822 58.646 130.422C68.446 140.422 89.8461 135.522 95.3461 126.022Z",
    fill: "#FFE016"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M100.446 111.022C100.379 111.689 100.313 112.389 100.246 113.122C99.446 107.122 97.1461 101.022 93.1461 96.2223C88.8461 91.0223 82.5461 87.4223 74.3461 87.6223C66.6461 87.8223 60.7461 92.3223 56.6461 97.0223C52.4461 101.922 50.2461 106.922 50.2461 106.922C50.9461 101.622 53.2461 96.8223 56.6461 93.1223C56.6461 93.1223 65.546 81.1223 81.746 83.7223C95.846 85.9223 101.246 103.322 100.446 111.022Z",
    fill: "#D42F55"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3463 146.522C88.5463 146.022 94.2463 143.422 98.9463 139.622C95.5463 143.422 89.4462 146.222 85.2462 148.222C60.2462 154.322 49.0463 140.222 48.4463 139.522C49.0463 140.022 59.0463 148.122 81.3463 146.522Z",
    fill: "white"
  }))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M93.7462 80.4223C98.8462 76.9223 102.446 83.3223 100.446 86.7223C98.4463 90.0223 91.2462 82.1223 93.7462 80.4223Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7461 152.222C75.0461 152.222 72.0461 149.522 72.5461 149.422C74.6461 148.922 80.4461 149.722 89.5461 145.322C90.4461 144.922 91.2462 148.222 90.4462 148.822C89.6462 149.522 79.7461 152.622 75.7461 152.222Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3463 143.822C68.8463 142.922 94.4462 132.222 96.5462 134.622C98.6462 137.022 92.0463 149.322 72.3463 143.822Z",
    fill: "#E02774"
  }))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9462 134.922C84.5462 134.122 90.1462 130.722 90.0462 132.022C89.8462 133.322 85.2462 135.322 84.9462 134.922Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1464 96.6222L67.6464 94.5222L66.8464 96.0222L66.5464 105.122L70.8464 104.422L71.1464 127.422V127.922L81.2463 128.522L81.9464 127.022L77.1464 96.6222Z",
    fill: "url(#paint8_linear_62_989)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9462 105.122L80.3462 92.4221L67.5461 94.5221L67.3462 100.122L67.2461 103.622L71.5461 102.922L71.8462 126.422L82.0461 127.022L80.9462 105.122Z",
    fill: "url(#paint9_linear_62_989)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9462 105.122C76.4462 104.622 71.0462 102.022 67.3462 100.122L67.5461 94.5221L80.3462 92.4221L80.9462 105.122Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2459 124.822C76.0459 126.022 80.746 127.022 80.546 124.822C80.446 122.622 82.346 116.822 78.946 118.222C75.646 119.522 72.1459 124.322 73.2459 124.822Z",
    fill: "#E02774"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M81.246 128.522L71.146 127.922C71.146 127.822 71.046 127.622 71.146 127.422C71.246 127.222 71.746 127.022 73.146 127.022C75.246 127.022 80.946 127.422 81.246 128.522Z",
    fill: "#BD3EA9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_62_989",
    x1: 72.1501,
    y1: 28.5802,
    x2: 72.1501,
    y2: 0.555218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE0057"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#83003B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_62_989",
    x1: 27.8092,
    y1: 20.2812,
    x2: 118.3,
    y2: 20.2812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A70057"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#83003B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_62_989",
    x1: -9.76581,
    y1: 88.8232,
    x2: -9.76581,
    y2: 9.43824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE0086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF003B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_62_989",
    x1: 67.7911,
    y1: 88.8232,
    x2: 67.7911,
    y2: 9.43824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE0086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF003B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_62_989",
    x1: 32.2332,
    y1: 148.453,
    x2: 32.2332,
    y2: 69.5522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_62_989",
    x1: 32.9162,
    y1: 152.946,
    x2: 32.9162,
    y2: 74.0402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FF3F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.718,
    stopColor: "#FF6A03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFF04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_62_989",
    x1: 32.2332,
    y1: 148.453,
    x2: 32.2332,
    y2: 69.5522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_62_989",
    x1: 46.837,
    y1: 136.123,
    x2: 46.837,
    y2: 83.3303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7C04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D92000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_62_989",
    x1: 36.8343,
    y1: 128.501,
    x2: 36.8343,
    y2: 94.5002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F63F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F66A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_62_989",
    x1: 33.983,
    y1: 126.988,
    x2: 33.983,
    y2: 92.3731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA900"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalFusion);
export default __webpack_public_path__ + "static/media/digital_fusion.7c0a1de0cc86800c9e0d9742c5544876.svg";
export { ForwardRef as ReactComponent };